import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function DevProfileLauncher() {
    const [id, setId] = useState("");
    const nav = useNavigate();

    return (
        <div style={{ padding: 24, maxWidth: 420, margin: "40px auto", fontFamily: "system-ui" }}>
            <h2>Profile URL Tester</h2>
            <p>Enter a user_id (users.id) and jump to their public profile page.</p>
            <input
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="e.g., 12"
                style={{ width: "100%", padding: 10, marginBottom: 12 }}
            />
            <button
                onClick={() => id && nav(`/profile/${encodeURIComponent(id)}`)}
                style={{ padding: "10px 16px", width: "100%" }}
            >
                Go to /profile/{`{id}`}
            </button>
            <div style={{ marginTop: 12, fontSize: 12, opacity: 0.8 }}>
                Tip: Also works with <code>/profile?id=12</code> thanks to dual mode.
            </div>
        </div>
    );
}
